import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

interface MarketingLink {
  label: string;
  icon: string;
  url: string;
}

@Component({
  selector: 'app-marketing',
  imports: [MatCardModule, MatIconModule, MatButtonModule],
  templateUrl: './marketing.component.html',
  styleUrl: './marketing.component.css',
})
export class MarketingComponent {
  readonly marketingHomeUrl =
    'https://landpoint227.sharepoint.com/sites/LandpointMarketing/SitePages/Marketing.aspx';

  readonly resources: MarketingLink[] = [
    {
      label: 'General',
      icon: 'dataset_linked',
      url: 'https://landpoint227.sharepoint.com/:f:/s/LandpointMarketing/EiKv9UIB23xLmoyG70J3kVwBbkP3ImGJ78MbJNrLRoFShw?e=ssMfhe',
    },
    {
      label: 'Account Management',
      icon: 'manage_accounts',
      url: 'https://landpoint227.sharepoint.com/:f:/s/LandpointMarketing/ErXCP71zGkNPhyCb_8gIzFwBDraD9VecExjPO2fEAoOx1g?e=sFIVyX',
    },
    {
      label: 'Business Cards',
      icon: 'style',
      url: 'https://landpoint227.sharepoint.com/:f:/s/LandpointMarketing/Enz0EWcJbExJh4HKOiU71IsBLJ0OHJF7UpaFTdf4DVcGNg?e=7KZq0g',
    },
    {
      label: 'Brand Manual',
      icon: 'developer_guide',
      url: 'https://landpoint227.sharepoint.com/:f:/s/LandpointMarketing/EjtBts-W8GVFitJeAgA8ZFkBZH23BJ7dGuXD8kdvtH-HHw?e=QOLxgP',
    },
    {
      label: 'Photos',
      icon: 'add_a_photo',
      url: 'https://landpoint227.sharepoint.com/:f:/s/LandpointMarketing/Em_AHGmtFlBKkFvyowlontQBDr3d-HCj03e6KECM0gDTCw?e=Kt96Og',
    },
    {
      label: 'Presentations',
      icon: 'co_present',
      url: 'https://landpoint227.sharepoint.com/:f:/s/LandpointMarketing/Evp4SJUq-nNFv48jQIVBhp4B0Bj5zh-Sffx7iIxCirnUig?e=CZZLNi',
    },
    {
      label: 'Templates',
      icon: 'grading',
      url: 'https://landpoint227.sharepoint.com/:f:/s/LandpointMarketing/EqxYRNNi0rpOnMaYjIKBoKgBDTmlcvh9hzaCHY7Njynj3g?e=SS0o0b',
    },
    {
      label: 'Brochures',
      icon: 'photo_album',
      url: 'https://landpoint227.sharepoint.com/:f:/s/LandpointMarketing/Es5Uk_NzHbxCqQoh0ZfwvwQBW_oi6iUqGSUKGoKo7qa83g?e=CVUKnl',
    },
    {
      label: 'Proposals',
      icon: 'real_estate_agent',
      url: 'https://landpoint227.sharepoint.com/:f:/s/LandpointMarketing/EgkjtCk1n1tJo33Hz1bWjeoBa7xmwUocvNntaQYwWylk3g?e=PdPVH8',
    },
    {
      label: 'BD Resumes',
      icon: 'work_alert',
      url: 'https://landpoint227.sharepoint.com/:f:/s/LandpointMarketing/EtJ4jlZkJ5VHs0xi5g8uH5cBv2O-65ngocx4_b4igdXZSg?e=KJWllz',
    },
    {
      label: 'Socials',
      icon: 'handshake',
      url: 'https://landpoint227.sharepoint.com/:f:/s/LandpointMarketing/EiEMRnGqF-lMheS6oniZC_EB9uG3WyamkSDsZ60uHpxcgQ?e=ScC2br',
    },
    {
      label: 'Events',
      icon: 'event_available',
      url: 'https://landpoint227.sharepoint.com/:f:/s/LandpointMarketing/ElTePAvAIqpHiY7oSMxHjHgBdoHen0Ze8VuUK7910gU1OQ?e=hdd661',
    },
  ];

  readonly forms: MarketingLink[] = [
    {
      label: 'Post Event Form',
      icon: 'assignment_turned_in',
      url: 'https://forms.cloud.microsoft/r/5NWGXNic8T',
    },
    {
      label: 'Event Request Form',
      icon: 'event',
      url: 'https://forms.cloud.microsoft/r/is47E5uLgd',
    },
    {
      label: 'Travel Request Form',
      icon: 'flight',
      url: 'https://forms.cloud.microsoft/r/BzRsR7WUij',
    },
  ];
}
